// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__G+0Lh","popup":"styles_popup__FzhT9","closeIcon":"styles_closeIcon__UKZ3u"};